<!-- 工单列表 -->
<template>
  <div class="tcdivideexpensebody">
      <div class="con">
          <div class="Files-top">
                <div class="ic-left">
                <span>分摊费</span>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="exportExcel" class="last-el-button">导出</el-button>
                </div>
          </div>
          <div class="search-input-btn">
            <div class="input-small">
              <span>用户名：</span>
               <el-input v-model="param" placeholder="请输入用户名" style="width:240px;" show-word-limit></el-input>
            </div>
            <div class="input-small" style="margin-left:20px">
              <span>日期：</span>
             <el-date-picker v-model="dataTime" value-format="timestamp"  type="datetimerange"
            range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </div>
            <el-button type="primary" plain class="search-btn" @click="search">查询</el-button>
          </div>
          <div class="illustrate">
             <span>空调内机总电量：{{sunInternalDeviceElectric}}KWH</span> 
             <span>空调外机总电量：{{sumOutsideDeviceElectric}}KWH</span>
             <span>公共区域总电量：{{sumPublicDeviceElectric}}KWH</span>
          </div>
          <div class="mytable" :style="{'height':heights+'px'}">
          <el-table :data="dataList" border style="width: 100%" :height="heights - 20" v-loading="loading">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column prop="userName" label="用户名">
              </el-table-column>
              <el-table-column prop="usersDeviceElectric" label="空调分摊电量">
              </el-table-column>
              <el-table-column prop="userAirMoney" label="空调分摊电费">
              </el-table-column>
              <el-table-column prop="publicDeviceElectric" label="公共区域分摊电量">
              </el-table-column>
              <el-table-column prop="publicDeviceMoney" label="公共区域分摊电费">
              </el-table-column>
              <el-table-column prop="status" :formatter="formatStatus" label="状态">
              </el-table-column>
              <el-table-column prop="sumMoney" label="合计（元）">
              </el-table-column>
            </el-table>
            </div>
             <div class="divider-line"></div>
              <div class="paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
              :current-page="pageIndex" :page-sizes="[20, 30, 40, 50, 60]" :page-size="10"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
      </div>
  </div>
</template>
<script>
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      elPagination,
    },
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-330,//屏幕高度 - 导航栏高度
        dataTime: [new Date(),new Date()],
        pageIndex: 1,
        pageSize: 10,
        status: '',
        param: '',
        dataList: [],
        total: 0,
        sumPublicDeviceElectric: '',
        sumOutsideDeviceElectric: '',
        sunInternalDeviceElectric: '',
        loading: false,
      }
    },
    created () {},
    mounted () {
      this.search()
    },
    destroyed () {},
    computed: {},
    watch: {
    },
    methods: {
      //分页功能 
      handleSizeChange (val) {
        this.pageSize=val;
        this.search()
      },
      handleCurrentChange (val) {
        this.pageIndex=val;
        this.search()
      },
      formatDatetime (row,col) {
        var dt=eval('row.'+col.property);
        return new Date(dt).format('yyyy-MM-dd hh:mm:ss');
      },
      formatStatus (row,col) {
        var s=eval('row.'+col.property);
        if(s==1) {
          return '待扣费';
        } else if(s==2) {
          return '已扣费';
        }
      },
      pageindexChange (val) {
        this.pageIndex=val;
        this.search()
      },
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.search()
      },
      viewDetails (item) {
        ningboStore.commit('setWorkorder',item);
        this.$router.push('/ningboWorkorderDetail');
      },
      editOwnerInfo (item) {
        ningboStore.commit('setWorkorder',item);
        this.$emit('edit',item);
      },
      search () {
        this.getWorkorderList()
      },
      getWorkorderList () {
        this.loading=true
        this.$api.tcFentanApi.divideFeeList(
          this.param,this.pageIndex-1,this.pageSize,this.dataTime[0].format('yyyy-MM-dd hh:mm:ss'),this.dataTime[1].format('yyyy-MM-dd hh:mm:ss'),respon => {
            this.total=respon['totalElements'];
            this.dataList=copy(this.cent2Yuan(respon['content']));
            this.loading=false
          }
        );
        this.$api.tcFentanApi.divideFeeSummary(
          this.param,this.pageIndex-1,this.pageSize,this.dataTime[0].format('yyyy-MM-dd hh:mm:ss'),this.dataTime[1].format('yyyy-MM-dd hh:mm:ss'),respon => {
            this.sumPublicDeviceElectric=respon['sumPublicDeviceElectric'];
            this.sumOutsideDeviceElectric=respon['sumOutsideDeviceElectric'];
            this.sunInternalDeviceElectric=respon['sunInternalDeviceElectric'];
          }
        );
      },
      //金额处理
      cent2Yuan (arr) {
        arr.forEach(function(item) {
          item.userAirMoney=(item.userAirMoney/100).toFixed(2);
          item.publicDeviceMoney=(item.publicDeviceMoney/100).toFixed(2);
          item.sumMoney=(item.sumMoney/100).toFixed(2);
        })
        return arr;
      },
      exportExcel () {
        //导出功能不行的
        this.$message.warning("功能暂未开放")
        return
        saveAs(DWSystemSetting.downloadUrl+'/'+this.dataList,'业主分摊费用表'+".xls")
      }
    }
  }
</script>

<style scoped lang="scss">
   .tcdivideexpensebody {
      .con {
         width: 100%;
         height: 100%;
         padding: 12px 20px;
         box-sizing: border-box;
         background-color: #fff;
         .illustrate {
          margin-bottom: 20px;
            span{
               margin-right: 40px;
               font-size: 16px;
            }
         }
         .mytable {
            width: 100%;
         }
         .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }
      }
   }
</style>